import React from 'react';
import classnames from 'classnames';

import { Address, useAddressLines } from '../../model/company';
import GlobalProps from '../globalProps';

import './Address.css';

interface Props extends GlobalProps {
  address: Address;
}

export function FormattedAddress({ address, className, style }: Props): JSX.Element | null {
  const lines = useAddressLines(address);
  if (Object.keys(address).length === 0) {
    return null;
  }
  return (
    <address className={classnames('address', className)} style={style}>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </address>
  );
}
